import { Box, Grid2, Pagination, Paper, Snackbar, SnackbarContent, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material"
import { useContext, useEffect, useState } from "react";
import MUICancelButton from "../../reusable_components/components/MuiCancelButton";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import '../jobPostings/jobpostings.css';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { TableLoader } from "../../reusable_components/components/TableLoader";
import { SnackbarContext } from "../../reusable_components/components/Snackbar";
import { useCandidateAllReferralCommissionMutation, useClientAllReferralCommissionMutation } from "../../redux/ReferralPayment/ReferralPayments.api";
import { useSelectRecruiterListMutation } from "../../redux/jobpostings/jobpostings.api";
import { Navigate, useNavigate } from "react-router-dom";


const ClientReferralPayment = () => {

    const { Snackbar } = useContext(SnackbarContext)
    const [showTableLoader, setShowTableLoader] = useState(false)
    const [clientPaymentDetails, setClientPaymentDetails] = useState([])

    // Pagination
    const [page, setPage] = useState(1)
    const [totalDataCount, setTotalDataCount] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [count, setCount] = useState(0)
    // const handleCloseFilterDialog = () => setFilterDialogOpen(false)
    const [triggerApi, setTriggerApi] = useState(false)



    const navigate = useNavigate()

    const [clientAllReferralCommission] = useClientAllReferralCommissionMutation()

    const handleChangePage = (e, newPage) => {
        setPage(newPage)
        setTriggerApi(true)
    }

    const getClientCommissions = async () => {
        try {
            const payload = {
                page: page ? page - 1 : 0,
                size: rowsPerPage ? rowsPerPage : 10,
            }
            setShowTableLoader(true)
            const response = await clientAllReferralCommission(payload).unwrap()
            setShowTableLoader(false)
            setClientPaymentDetails(response?.response?.data)
            setTotalDataCount(response?.response?.totalItems)

        } catch (error) {
            Snackbar("Network error", 'error')
        }
    }

    useEffect(() => {
        getClientCommissions()

    }, [])

    useEffect(() => {
        if (triggerApi) {
            getClientCommissions()
            // handleCloseFilterDialog()
            setTriggerApi(false)
        }
    }, [rowsPerPage, page, triggerApi])

    const handleViewClick = (item) => {
        navigate("/view-client-payment", {
            state: {
                clientId: item?.clientId, positionName: item?.positionName, recruiterId: item?.recruiterId, recruiterName: item?.recruiterName, recruiterEmail: item?.recruiterEmail, positionId: item?.positionId,
                clientName: item?.clientName
            }

        }
        )
    }

    return (
        <Box>
            <Grid2 item sx={{ marginTop: "20px" }}>
                <Paper sx={{ width: '100%', overflow: 'auto', border: '1px solid #E9EAEB' }} elevation={0}>
                    <Table>
                        <TableHead style={{
                            position: 'sticky',
                            top: 0,
                            zIndex: 10,
                            width: '100%',
                        }}>
                            <TableRow sx={{
                                '& .MuiTableCell-root': {
                                    borderBottom: 'none',
                                }
                            }}>
                            </TableRow>
                            <TableRow>
                                <TableCell className="tableHeadersCell" >Business Associate </TableCell>
                                <TableCell className="tableHeadersCell">Referral Client</TableCell>
                                {/* <TableCell className="tableHeadersCell">Job Position</TableCell> */}
                                <TableCell className="tableHeadersCell">Reward Type</TableCell>
                                <TableCell className="tableHeadersCell" >Rewards</TableCell>
                                <TableCell className="tableHeadersCell"> Total Earings</TableCell>
                                <TableCell className="tableHeadersCell" >Action</TableCell>
                            </TableRow>
                        </TableHead>

                        {!showTableLoader ? (
                            clientPaymentDetails?.length > 0 ? (
                                <TableBody>
                                    {clientPaymentDetails?.map((item, index) => (
                                        <TableRow key={index}
                                            sx={{
                                                backgroundColor: index % 2 === 1 ? '#FAFAFA' : 'inherit',
                                                '&:hover': { backgroundColor: '#f1f1f1' },
                                            }}>
                                            <TableCell
                                                className="tableBodyCell"

                                            >
                                                <span style={{ color: '#53389E', fontWeight: 600, }}>
                                                    {item.recruiterId} {item?.recruiterName}
                                                </span> <br />
                                                <span>  {item?.recruiterEmail}</span>

                                            </TableCell>
                                            <TableCell className="tableBodyCell">
                                                <span style={{ color: '#53389E', fontWeight: 600, cursor: 'pointer' }}>
                                                    {item.clientId}
                                                </span> {item?.clientName}

                                            </TableCell>
                                            {/* <TableCell className="tableBodyCell">
                                                <span style={{ color: '#53389E', fontWeight: 600, cursor: 'pointer' }}>
                                                    {item.positionId}
                                                </span> {item?.positionName}
                                            </TableCell> */}
                                            <TableCell className='tableBodyCell'>{item?.clientRewardType === "FC" ? "Fixed Amount" : "Fixed Percentage"}<br></br>
                                            </TableCell>
                                            <TableCell className='tableBodyCell'>
                                                {item?.clientRewardType === "FC"
                                                    ? <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                        <CurrencyRupeeIcon sx={{ fontSize: '14px', color: '#a6aba5' }} />
                                                        <Typography sx={{ fontSize: '12.5px' }}>
                                                            {item?.clientRewardAmount}
                                                        </Typography>
                                                    </Box>
                                                    : item?.clientRewardPct != null
                                                        ? <span style={{ marginLeft: '14px' }}>{item?.clientRewardPct}%</span>
                                                        : '-'
                                                }
                                            </TableCell>
                                            <TableCell className='tableBodyCell'>
                                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                    <CurrencyRupeeIcon sx={{ fontSize: '14px', color: '#a6aba5' }} />
                                                    <Typography sx={{ fontSize: '12.5px' }}>
                                                        {item?.totalAmount}
                                                    </Typography>
                                                </Box>

                                            </TableCell>
                                            <TableCell onClick={() => handleViewClick(item)} className='tableBodyCell' sx={{ color: '#6941C6', fontWeight: 'bold', cursor: 'pointer' }} >View</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            ) : (
                                <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={8}>
                                            <Typography className="emptydatas">No Data Found</Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            )
                        ) : (
                            <TableRow>
                                <TableCell colSpan={13}>
                                    <Box className='tableloader'>
                                        <TableLoader />
                                    </Box>
                                </TableCell>
                            </TableRow>
                        )}
                        {Math.ceil(totalDataCount / rowsPerPage) > 1 && (
                            <TableRow>
                                <TableCell colSpan={100}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <MUICancelButton
                                            title='Previous'
                                            startIcon={<ArrowBackIcon sx={{ color: page === 1 ? '#a2a2a2' : '#414651' }} />}
                                            onClick={() => handleChangePage(null, page - 1)}
                                            disabled={page === 1}
                                            sx={{ height: '36px' }}
                                        />

                                        <Pagination
                                            page={page}
                                            onChange={handleChangePage}
                                            count={Math.ceil(totalDataCount / rowsPerPage)}
                                            siblingCount={1}
                                            boundaryCount={1}
                                            shape="rounded"
                                            hidePrevButton
                                            hideNextButton
                                        />

                                        <MUICancelButton
                                            title='Next'
                                            startIcon={<ArrowForwardIcon sx={{ color: page === Math.ceil(totalDataCount / rowsPerPage) ? '#a2a2a2' : '#414651' }} />}
                                            onClick={() => handleChangePage(null, page + 1)}
                                            disabled={page === Math.ceil(totalDataCount / rowsPerPage)}
                                            sx={{ height: '36px' }}
                                        />
                                    </div>
                                </TableCell>
                            </TableRow>
                        )}
                        {
                            Math.ceil(count / rowsPerPage) > 1 && (
                                <TableRow>
                                    <TableCell colSpan={100}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <MUICancelButton
                                                title='Previous'
                                                startIcon={<ArrowBackIcon sx={{ color: page === 1 ? '#a2a2a2' : '#414651' }} />}
                                                onClick={() => handleChangePage(null, page - 1)}
                                                disabled={page === 1}
                                                sx={{ height: '36px' }}
                                            />

                                            <Pagination
                                                page={page}
                                                onChange={handleChangePage}
                                                count={Math.ceil(count / rowsPerPage)}
                                                siblingCount={1}
                                                boundaryCount={1}
                                                shape="rounded"
                                                hidePrevButton
                                                hideNextButton
                                            />

                                            <MUICancelButton
                                                title='Next'
                                                startIcon={<ArrowForwardIcon sx={{ color: page === Math.ceil(count / rowsPerPage) ? '#a2a2a2' : '#414651' }} />}
                                                onClick={() => handleChangePage(null, page + 1)}
                                                disabled={page === Math.ceil(count / rowsPerPage)}
                                                sx={{ height: '36px' }}
                                            />
                                        </div>
                                    </TableCell>
                                </TableRow>
                            )}
                    </Table>
                </Paper>
            </Grid2>

        </Box>
    )
}
export default ClientReferralPayment;